import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-nightingale-series-options',
	templateUrl:'./AgNightingaleSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgNightingaleSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgNightingaleSeriesPluginCompPage
{
	mdContent_745 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgNightingaleSeriesOptions;
\`\`\``;
}
